module.exports = "/_next/static/images/CardProfile@2x-91ab50c6efde23d37b87212331dba501.png";